import { type FC } from "react";

import { labelFor } from "@components/Prompts/constants";
import { type ReportTypeValue } from "@pages/Templates/constants";
import { type PromptReportTypeMismatch, promptMismatchKey } from "@pages/Templates/promptReportType";

/** Shared wording for the type-switch and publish warnings. */
export const PromptReportTypeMismatchList: FC<{
  mismatches: readonly PromptReportTypeMismatch[];
  reportType: string;
}> = ({ mismatches, reportType }) => {
  const label = labelFor(reportType as ReportTypeValue);
  return (
    <div className="flex flex-col gap-2 text-sm text-text-secondary">
      <p>
        {mismatches.length === 1 ? "This AI prompt isn't" : `These ${mismatches.length} AI prompts aren't`} tagged for{" "}
        {label}. Switch {mismatches.length === 1 ? "it" : "them"} to the {label} version on the Structure tab.
      </p>
      <ul className="list-disc pl-5">
        {mismatches.map((m) => (
          <li key={promptMismatchKey(m)}>
            {m.sectionTitle} › {m.fieldTitle}: <span className="font-medium text-text-primary">{m.promptName}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
